var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgAvalanche = function SvgAvalanche(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 25",
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 12.932c0 6.627-5.373 12-12 12s-12-5.372-12-12c0-6.627 5.373-12 12-12s12 5.373 12 12Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.6 17.707H6.27c-.489 0-.73 0-.878-.094a.592.592 0 0 1-.268-.463c-.009-.174.112-.386.354-.81l5.75-10.136c.245-.43.368-.646.525-.725a.593.593 0 0 1 .536 0c.156.08.28.294.525.725l1.182 2.063.006.01c.264.463.398.697.457.942.065.269.065.552 0 .82-.06.248-.192.484-.46.952l-3.02 5.34-.008.013c-.266.466-.401.702-.588.88a1.756 1.756 0 0 1-.716.415c-.245.068-.52.068-1.067.068ZM14.48 17.707h3.338c.492 0 .74 0 .887-.097a.59.59 0 0 0 .268-.466c.009-.168-.11-.372-.341-.772l-.024-.041-1.672-2.86-.019-.032c-.235-.397-.353-.598-.505-.675a.587.587 0 0 0-.534 0c-.153.08-.277.289-.522.71l-1.665 2.86-.006.01c-.244.42-.366.63-.357.803a.597.597 0 0 0 .268.466c.145.094.392.094.885.094Z",
    fill: "#000"
  })));
};

export default SvgAvalanche;